<script>
  import { createEventDispatcher } from 'svelte';
  import { deletePublishedComment, updateAdminComment } from '../../../Api/api';
  import { getTime } from '../../../common/dates';
  import { containsLink, setLink } from '../../../common/utils.js';

  const dispatch = createEventDispatcher();

  export let history = [];
  export let channelId = '';
  export let currentId = '';

  let editId;
  let editContent;

  const onUndoBtnClicked = async (comment) => {
    deletePublishedComment(currentId, comment.commentId).then((res) => console.log(res));
  };

  const onEditBtnClicked = async (comment) => {
    editId = comment.commentId;
    editContent = comment.content;
  };

  async function onUpdateComment(comment) {
    editId = undefined;
    await updateAdminComment(channelId, comment.commentId, editContent);
  }

  const onEditKeyDown = (e, comment) => {
    if (e.key === 'Enter') {
      onUpdateComment(comment);
    } else if (e.key === 'Escape') {
      editId = undefined;
    }
  };

  const onCancelEditBtnClicked = () => {
    editId = undefined;
  };
</script>

<div class="history">
  <header>
    <h1>Historikk</h1>
    <div class="controls">
      <button on:click={() => dispatch('close')}><span class="material-icons">close</span></button>
    </div>
  </header>
  <div class="list">
    {#each history as comment}
      <div class="comment">
        <span class="time-stamp">{getTime(comment.created.toDate())}</span>
        <span class="user-name">{comment.userName}</span>
        <span class="content">
          {#if comment.commentId === editId}
            <input
              class="edit-input"
              bind:value={editContent}
              on:keydown={(e) => onEditKeyDown(e, comment)}
            />
          {:else if containsLink(comment.content)}
            {@html setLink(comment.content)}
          {:else}
            {comment.content}
          {/if}
        </span>
        {#if comment.a}
          <span class="published-indicator" />
        {:else if comment.d}
          <span class="deleted-indicator" />
        {/if}
        <button class="undo-btn" disabled={!comment.a} on:click={() => onUndoBtnClicked(comment)}
          >Angre
        </button>
        {#if comment.m && comment.commentId === editId}
          <button class="ok-btn" on:click={() => onUpdateComment(comment)}>Lagre </button>
          <button class="cancel-btn" on:click={onCancelEditBtnClicked}>Avbryt </button>
        {:else if comment.m}
          <button class="edit-btn" on:click={() => onEditBtnClicked(comment)}>Endre </button>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style src="./history.scss"></style>
